(function () {
  var FIELD_LABELS = ['sizing info', 'usual size'];
  var scheduleId = null;
  var DATE_PATTERN = /^(\d{1,2}\/\d{1,2}\/\d{4}|\d{4}-\d{1,2}-\d{1,2})$/;

  function normalize(text) {
    return String(text || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function hasTargetLabel(element) {
    var label = element.querySelector(
      '.jdgm-rev__cf-question, [class*="question"], [class*="label"]'
    );
    var text = normalize(label ? label.textContent : element.textContent);

    return FIELD_LABELS.some(function (fieldLabel) {
      return text.indexOf(fieldLabel) !== -1;
    });
  }

  function isCompactFieldElement(element) {
    var text = normalize(element.textContent);

    if (!text || text.length > 120 || !hasTargetLabel(element)) return false;
    if (element.querySelector('.jdgm-rev__title, .jdgm-rev__body, .jdgm-rev__timestamp')) return false;

    return true;
  }

  function getCustomFields(review) {
    var rows = Array.prototype.slice.call(review.querySelectorAll('.jdgm-rev__cf-ans'));
    var matchingRows = rows.filter(hasTargetLabel);

    if (matchingRows.length) {
      return matchingRows;
    }

    var customContainers = Array.prototype.slice.call(
      review.querySelectorAll('.jdgm-rev__custom-form, [class*="custom"][class*="form"]')
    );
    var matchingContainers = customContainers.filter(isCompactFieldElement);

    if (matchingContainers.length) return matchingContainers;

    return [];
  }

  function getDateElement(review) {
    var dateElement = review.querySelector(
      '.jdgm-rev__timestamp, .jdgm-rev__date, .jdgm-rev__date-wrapper, time'
    );

    if (dateElement) return dateElement;

    return Array.prototype.slice.call(review.querySelectorAll('span, div, time')).find(function (element) {
      return DATE_PATTERN.test(String(element.textContent || '').trim());
    });
  }

  // function ensureTarget(review) {
  //   var target = review.querySelector('.jdgm-rev__date-custom-fields');
  //   var title = review.querySelector('.jdgm-rev__title');
  //   var dateElement = getDateElement(review);

  //   if (!target) {
  //     target = document.createElement('div');
  //     target.className = 'jdgm-rev__date-custom-fields';
  //   }

  //   if (title && target.nextElementSibling !== title) {
  //     title.insertAdjacentElement('beforebegin', target);
  //   } else if (dateElement && target.previousElementSibling !== dateElement) {
  //     dateElement.insertAdjacentElement('afterend', target);
  //   }

  //   return target;
  // }

  function removeEmptyContainers(review) {
    Array.prototype.forEach.call(review.querySelectorAll('.jdgm-rev__custom-form'), function (container) {
      if (!container.querySelector('.jdgm-rev__cf-ans') && !normalize(container.textContent)) {
        container.remove();
      }
    });
  }

  function moveReviewFields(review) {
    var dateElement = getDateElement(review);
    if (!dateElement) return;

    var fields = getCustomFields(review);
    if (!fields.length) return;

    var target = ensureTarget(review);

    fields.forEach(function (field) {
      if (field === target || target.contains(field)) return;
      target.appendChild(field);
    });

    removeEmptyContainers(review);
  }

  function moveAllReviewFields() {
    scheduleId = null;
    Array.prototype.forEach.call(document.querySelectorAll('.jdgm-rev'), moveReviewFields);
  }

  function scheduleMove() {
    if (scheduleId) return;
    scheduleId = window.setTimeout(moveAllReviewFields, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleMove);
  } else {
    scheduleMove();
  }

  window.addEventListener('load', scheduleMove);

  if ('MutationObserver' in window) {
    new MutationObserver(scheduleMove).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();